import { Component, Input, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { AspectRatio } from '@knorr-bremse-portals/ngx-components';
import { InnerSection, AnyInnerSection } from '../../types/section';
import { CommonModule } from '@angular/common';
import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { OgImageDirective } from '../../directives/og-image.directive';
import { InnerSectionComponent } from '../inner-section/inner-section.component';
import { IMAGE_COMPONENT_NAME, SrcSetImageAttributes, SrcSetImageEditorIds } from '../../../app/types/image';
import { PictureComponent, PictureSources, SourceSet } from '@knorr-bremse-portals/ngx-components/components/picture';

export interface Picture {
  sources: PictureSources;
  alt: string;
}

export function urlToPicture(url: string, alt?: string): Picture {
  return {
    alt: alt ?? '',
    sources: {
      'original': {
        '?': url,
      },
    },
  };
}

export function imageToPicture(image: SrcSetImageAttributes, aspectRatio: AspectRatio): Picture {

  const picture: Picture = {
    alt: image.alt,
    sources: {
      'original': {
        '?': image.src,
      },
    },
  }

  if (image.srcset) {
    const sourceSet: SourceSet =  Object.assign({}, ...(image.srcset.map(item => ({[item.width]: item.src}))));
    picture.sources[aspectRatio] = sourceSet;
  }

  return picture;
}

export type PlainImageSection = InnerSection<SrcSetImageAttributes, SrcSetImageEditorIds, typeof IMAGE_COMPONENT_NAME>;

export function isPlainImageSection(section: AnyInnerSection): section is PlainImageSection {
  return section.component === IMAGE_COMPONENT_NAME;
}

@Component({
  selector: 'app-plain-image',
  styleUrls: ['./plain-image.component.scss'],
  templateUrl: './plain-image.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ CommonModule, PictureComponent, EditorIdDirective, OgImageDirective ],
})
export class PlainImageComponent extends InnerSectionComponent<PlainImageSection> implements OnInit {
  @Input() public imageClass!: string;
  @Output() public readonly loaded = new EventEmitter<Event>();

  protected srcsetAttribute?: string;

  public ngOnInit() {
    if (this.attributes.srcset) {
      this.srcsetAttribute = '';
      for (const src of this.attributes.srcset) {
        this.srcsetAttribute += `${src.src} ${src.width}w,`;
      }
    }
  }

}
